import axios from 'axios';
import { useEffect, useState } from 'react';
import './App.css';
// import Countries from './Countries';


function App() {
  let [countries,setCountries] = useState([]);
  // Initial Display
  useEffect(()=>{
    axios.get('https://restcountries.com/v3.1/all').then((res)=>{
      setCountries(res.data)
    })
    .catch((e)=>{
      console.log('errors:'+e); 
    })
  },[]);

  return (
    <div className="App">
      <div className='header'>
        <div className='headerContents'>
          <h1>Where in the world?</h1>
          <p>Let's find the country information!</p>
        </div>
      </div>

      <div className='mainArea'>
        {/* Search Countries */}
        <div className='search'>
          <div className='serchBox'>
            <svg viewBox="0 0 512 512">
              <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
            </svg>
            <input type="text" placeholder='Serach for a country...'onChange={(e)=>{
              let input = e.target.value;
              if(input == ''){
                  axios.get('https://restcountries.com/v3.1/all').then((res)=>{
                    setCountries(res.data)
                  })
                  .catch((e)=>{
                    console.log('errors:'+e); 
                  });
              } else {
                let getByName = 'https://restcountries.com/v3.1/name/'+input;
                axios.get(getByName).then((res)=>{
                  setCountries(res.data)
                })
                .catch((e)=>{
                  console.log('errors:'+e); 
                });
              }
            }}/>
          </div>
          <div className='region'>
            <label htmlFor="region"></label>
            <select name="region" id="region" onChange={(e)=>{
              let option = e.target.value;
              if(option == 'filter'){
                axios.get('https://restcountries.com/v3.1/all').then((res)=>{
                    setCountries(res.data)
                  })
                  .catch((e)=>{
                    console.log('errors:'+e); 
                  });
              }
              let getByName = 'https://restcountries.com/v3.1/region/'+option;
                axios.get(getByName).then((res)=>{
                  setCountries(res.data)
                })
                .catch((e)=>{
                  console.log('errors:'+e); 
                });
            }}>
              <option value="filter">Filter by Region</option>
              <option value="africa">Africa</option>
              <option value="america">America</option>
              <option value="asia">Asia</option>
              <option value="europe">Europe</option>
              <option value="oceania">Oceania</option>
            </select>
          </div>
        </div>
        {/* Show Countries */}
        <ul className='countryListing'>
          {countries.map((con,i)=>{
            return (
              <li key={i} className="countryCard">
                <img src={countries[i].flags.png} alt={countries[i].name.common+' flag'} width="266px" height="auto"/>
                <p><strong>{countries[i].name.common}</strong></p>
                <ul>
                  <li><b>Population: </b>{countries[i].population.toLocaleString()}</li>
                  <li><strong>Region: </strong>{countries[i].region}</li>
                  <li><strong>Capital: </strong>{countries[i].capital}</li>
                </ul>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  );
}

export default App;
